import { Link } from 'react-router-dom'
import { ArrowRight, Instagram, Facebook, Dribbble, Mail, Phone, MapPin } from 'lucide-react'

const portfolioLinks = [
  { label: 'Technoarreda | Interior Design', href: 'https://technoarreda-interior-design.vercel.app/' },
  { label: 'Nymphai | Cosematics', href: 'https://nymphai-cosematics.vercel.app/' },
  { label: 'Redsun | Business', href: 'https://redsun-business-website.vercel.app/' },
  { label: 'Voxelo | E-Commerce Solution', href: 'https://voxelo-ecommerce-solution.vercel.app/' },
  { label: 'Loud | Digital', href: 'https://loud-digital.vercel.app' },
  { label: 'Music | history', href: 'https://music-history-three.vercel.app/' },
  { label: 'Stokt | AI', href: 'https://stokt-cretive-design.vercel.app' },
  { label: 'Buck Sauce | Food', href: 'https://buck-sauce.vercel.app' },
  

 

  



]

const serviceLinks = [
  { label: 'Website Development', href: '/services/web-dev' },
  { label: 'Branding & Design', href: '/services/branding' },
  { label: 'CRM Systems', href: '/services/crm' },
  { label: 'E-Commerce', href: '/services/ecommerce' },
  { label: 'Landing Pages', href: '/services/landing' },
  { label: 'SaaS Platforms', href: '/services/saas' },
  { label: 'AI Agents & Automation', href: '/services/ai' },
  { label: 'SEO & Paid Growth', href: '/services/seo' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Delivery Process', href: '/process' },
]

const aboutLinks = [
  { label: 'ABOUT', href: '/about' },
  { label: 'AWARDS', href: '/awards' },
  { label: 'REVIEWS', href: '/awards' },
  { label: 'CONTACT US', href: '/contacts' },
]

export default function Footer() {
  return (
    <footer className="relative bg-[#050505] pt-20 pb-8 overflow-hidden">
      {/* Giant TECHNIFIRE text */}
      <div className="w-full px-6 lg:px-10 mb-16">
        <h2 className="text-[clamp(60px,18vw,260px)] font-bold leading-none tracking-tighter bg-gradient-to-r from-[#B7000E] via-[#b7000f94] to-[#b7000f5f] bg-clip-text text-transparent select-none">
          TECHNIFIRE
        </h2>
      </div>

      {/* Main footer content */}
      <div className="w-full px-6 lg:px-10">
        {/* Tagline */}
        <div className="mb-12 pb-10 border-b border-white/10">
          <p className="text-xl lg:text-2xl text-white/60 max-w-2xl">
            Building digital products that drive real business results.
            US-registered company serving clients worldwide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          {/* Portfolio column */}
          <div>
            <h4 className="text-mono text-[#9A9A9A] mb-4">Portfolio</h4>
            <ul className="space-y-2">
              {portfolioLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} target='_blank' className="text-sm text-[#9A9A9A] hover:text-white transition-colors flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-[#9A9A9A]" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services column */}
          <div>
            <h4 className="text-mono text-[#9A9A9A] mb-4">Services</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-[#9A9A9A] hover:text-white transition-colors flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-[#9A9A9A]" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About + Contact column */}
          <div>
            <div className="flex gap-3 mb-6">
              <span className="text-mono text-[#9A9A9A]">UA</span>
              <span className="text-mono text-white">EN</span>
            </div>
            <ul className="space-y-2 mb-8">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-[#9A9A9A] hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2 text-[#9A9A9A]">
                <MapPin className="w-3.5 h-3.5 shrink-0" />
                <span>8301 State Line Rd Ste 220 # 3747, Kansas City, MO 64114-2025</span>
              </div>
              <div className="flex items-center gap-2 text-[#9A9A9A]">
                <Phone className="w-3.5 h-3.5 shrink-0" />
                <a href="tel:+14255414001" className="text-white hover:text-[#9A9A9A] transition-colors">+1 (425) 541-4001</a>
              </div>
              <div className="flex items-center gap-2 text-[#9A9A9A]">
                <Mail className="w-3.5 h-3.5 shrink-0" />
                <a href="mailto:info@technifire.io" className="text-white hover:text-[#9A9A9A] transition-colors">info@technifire.io</a>
              </div>  
            </div>
          </div>

          {/* Contact CTA column */}
          <div>
            <h4 className="text-mono text-[#9A9A9A] mb-4">Start a Project</h4>
            <p className="text-sm text-[#9A9A9A] mb-4">
              Ready to build something great? Get a free consultation and detailed proposal within 24 hours.
            </p>
            <Link to="/contacts" className="btn-primary mb-6 text-sm">
              BOOK A STRATEGY CALL
              <ArrowRight className="w-4 h-4" />
            </Link>

            {/* Project thumbnails strip */}
            <div className="flex gap-2 mb-6">
              {['/images/stokt.png', '/images/cosematics.png', '/images/redsun.png', '/images/voxelo.png'].map((src, i) => (
                <div key={i} className="w-14 h-10 rounded-lg overflow-hidden bg-[#111]">
                  <img src={src} alt="" className="w-full h-full object-cover" />
                </div>
              ))}
            </div>

            {/* Social icons */}
            <div className="flex items-center gap-3">
              <a href="https://instagram.com/technifire.io" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <Link to="https://www.facebook.com/technifire.io" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <Facebook className="w-4 h-4" />
              </Link>
              <a href="https://behance.net/technifire" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <span className="text-xs font-bold">Be</span>
              </a>
              <a href="https://dribbble.com/technifire" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center text-white hover:bg-white/10 transition-colors">
                <Dribbble className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-white/10">
          <div className="flex items-center gap-4 text-xs text-[#9A9A9A]">
            <span>TECHNIFIRE  LLC</span>
            <span>|</span>
            <span>8301 State Line Rd Ste 220 # 3747, Kansas City, MO 64114-2025</span>
            <span>|</span>
            <span>© 2026 ALL RIGHTS RESERVED</span>
          </div>
          <div className="flex items-center gap-4 text-xs text-[#9A9A9A]">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">PRIVACY POLICY</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">TERMS OF SERVICE</Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors">REFUND POLICY</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
